"use client";
import { j as w } from "./jsx-runtime-CJ-St4mQ.mjs";
import { t as y } from "./tv.config-BuYIgndg.mjs";
const m = y({
  base: "",
  variants: {
    container: {
      true: "grid-root flex flex-row flex-wrap min-w-0 box-border",
      false: "Grid__item basis-auto flex-grow-0 min-w-0 box-border"
    },
    spacing: {
      0: ["gap-0"],
      1: ["gap-1"],
      2: ["gap-2"],
      3: ["gap-3"],
      4: ["gap-4"],
      5: ["gap-5"],
      6: ["gap-6"],
      7: ["gap-7"],
      8: ["gap-8"],
      9: ["gap-9"],
      10: ["gap-10"],
      11: ["gap-11"],
      12: ["gap-12"],
      16: ["gap-16"],
      20: ["gap-20"],
      24: ["gap-12"]
    },
    rowSpacing: {
      0: ["gap-y-0"],
      1: ["gap-y-1"],
      2: ["gap-y-2"],
      3: ["gap-y-3"],
      4: ["gap-y-4"],
      5: ["gap-y-5"],
      6: ["gap-y-6"],
      7: ["gap-y-7"],
      8: ["gap-y-8"],
      9: ["gap-y-9"],
      10: ["gap-y-10"],
      11: ["gap-y-11"],
      12: ["gap-y-12"],
      16: ["gap-y-16"],
      20: ["gap-y-20"],
      24: ["gap-y-12"]
    },
    columnSpacing: {
      0: ["gap-x-0"],
      1: ["gap-x-1"],
      2: ["gap-x-2"],
      3: ["gap-x-3"],
      4: ["gap-x-4"],
      5: ["gap-x-5"],
      6: ["gap-x-6"],
      7: ["gap-x-7"],
      8: ["gap-x-8"],
      9: ["gap-x-9"],
      10: ["gap-x-10"],
      11: ["gap-x-11"],
      12: ["gap-x-12"],
      16: ["gap-x-16"],
      20: ["gap-x-20"],
      24: ["gap-x-12"]
    },
    // size: {
    //   1: "w-[calc(theme(width.1/12)-(12-1)*(var(--Grid-spacing)*4px/12))]",
    //   2: "w-[calc(theme(width.2/12)-(12-2)*(var(--Grid-spacing)*4px/12))]",
    //   3: "w-[calc(theme(width.3/12)-(12-3)*(var(--Grid-spacing)*4px/12))]",
    //   4: "w-[calc(theme(width.4/12)-(12-4)*(var(--Grid-spacing)*4px/12))]",
    //   5: "w-[calc(theme(width.5/12)-(12-5)*(var(--Grid-spacing)*4px/12))]",
    //   6: "w-[calc(theme(width.6/12)-(12-6)*(var(--Grid-spacing)*4px/12))]",
    //   7: "w-[calc(theme(width.7/12)-(12-7)*(var(--Grid-spacing)*4px/12))]",
    //   8: "w-[calc(theme(width.8/12)-(12-8)*(var(--Grid-spacing)*4px/12))]",
    //   9: "w-[calc(theme(width.9/12)-(12-9)*(var(--Grid-spacing)*4px/12))]",
    //   10: "w-[calc(theme(width.10/12)-(12-10)*(var(--Grid-spacing)*4px/12))]",
    //   11: "w-[calc(theme(width.11/12)-(12-11)*(var(--Grid-spacing)*4px/12))]",
    //   12: "w-[calc(theme(width.full)-(12-12)*(var(--Grid-spacing)*4px/12))]",
    // },
    direction: {
      row: "flex-row",
      "row-reverse": "flex-row-reverse",
      column: "flex-col",
      "column-reverse": "flex-col-reverse"
    },
    wrap: {
      nowrap: "flex-nowrap",
      "wrap-reverse": "flex-wrap-reverse",
      wrap: "flex-wrap"
    },
    align: {
      start: "items-start",
      center: "items-center",
      end: "items-end"
    },
    justify: {
      start: "justify-start",
      center: "justify-center",
      end: "justify-end",
      between: "justify-between",
      around: "justify-around"
    }
  }
}), f = y({
  base: [],
  variants: {
    size: {
      1: "w-[calc(theme(width.1/12)-(12-1)*(var(--Grid-spacing)*4px/12))]",
      2: "w-[calc(theme(width.2/12)-(12-2)*(var(--Grid-spacing)*4px/12))]",
      3: "w-[calc(theme(width.3/12)-(12-3)*(var(--Grid-spacing)*4px/12))]",
      4: "w-[calc(theme(width.4/12)-(12-4)*(var(--Grid-spacing)*4px/12))]",
      5: "w-[calc(theme(width.5/12)-(12-5)*(var(--Grid-spacing)*4px/12))]",
      6: "w-[calc(theme(width.6/12)-(12-6)*(var(--Grid-spacing)*4px/12))]",
      7: "w-[calc(theme(width.7/12)-(12-7)*(var(--Grid-spacing)*4px/12))]",
      8: "w-[calc(theme(width.8/12)-(12-8)*(var(--Grid-spacing)*4px/12))]",
      9: "w-[calc(theme(width.9/12)-(12-9)*(var(--Grid-spacing)*4px/12))]",
      10: "w-[calc(theme(width.10/12)-(12-10)*(var(--Grid-spacing)*4px/12))]",
      11: "w-[calc(theme(width.11/12)-(12-11)*(var(--Grid-spacing)*4px/12))]",
      12: "w-[calc(theme(width.full)-(12-12)*(var(--Grid-spacing)*4px/12))]"
    }
  }
}), J = (u) => {
  const {
    className: e,
    container: r,
    spacing: i,
    rowSpacing: h,
    columnSpacing: s,
    size: a,
    direction: v,
    wrap: j,
    justify: G,
    justifyContent: b,
    align: S,
    item: _,
    xs: t,
    sm: c,
    md: g,
    lg: n,
    xl: o,
    ...l
  } = u, z = S || b;
  if (r)
    return /* @__PURE__ */ w.jsx(
      "div",
      {
        ...l,
        className: m({
          class: e,
          container: r,
          spacing: i,
          columnSpacing: s,
          rowSpacing: h,
          direction: v,
          wrap: j,
          justify: G,
          align: z
        }),
        style: { "--Grid-spacing": i || s }
      }
    );
  const C = {
    ...typeof a == "object" ? a : {},
    ...t ? { xs: t } : {},
    ...c ? { sm: c } : {},
    ...g ? { md: g } : {},
    ...n ? { lg: n } : {},
    ...o ? { xl: o } : {}
  }, p = [];
  typeof a == "number" && p.push(f({ size: a, class: e }));
  for (const [x, d] of Object.entries(C)) {
    if (!d) continue;
    const N = x === "base" ? "" : `${x}:`, $ = f({ size: d, class: e });
    p.push(`${N}${$}`);
  }
  return /* @__PURE__ */ w.jsx("div", { ...l, className: [m(), ...p].join(" ") });
};
export {
  J as default
};
